import script from "./ContractVehiclesBannerComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContractVehiclesBannerComponent.vue?vue&type=script&lang=ts&setup=true"

import "./ContractVehiclesBannerComponent.vue?vue&type=style&index=0&id=6754fcd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6754fcd0"]])

export default __exports__